(function() {
  'use strict';

  var RECENTLY_VIEWED_KEY = 'theme:recently-viewed';
  var SEEN_STORIES_KEY = 'tp:seen-stories';

  // ==================== SHARED CONFIG ====================

  var _config = null;

  function getConfig() {
    if (_config) return _config;
    var configEl = document.querySelector('[data-hero-section-config]');
    if (!configEl) return null;
    try { _config = JSON.parse(configEl.textContent); } catch (e) { return null; }
    return _config;
  }

  // ==================== SCROLL ARROWS ====================

  function initScrollArrows(scrollEl, leftArrow, rightArrow, visibleClass) {
    if (!scrollEl || !leftArrow || !rightArrow) return;

    function updateArrows() {
      var scrollLeft = scrollEl.scrollLeft;
      var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
      leftArrow.classList.toggle(visibleClass, scrollLeft > 5);
      rightArrow.classList.toggle(visibleClass, maxScroll > 5 && scrollLeft < maxScroll - 5);
    }

    leftArrow.addEventListener('click', function() {
      scrollEl.scrollBy({ left: -200, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', function() {
      scrollEl.scrollBy({ left: 200, behavior: 'smooth' });
    });

    var resizeRaf = null;
    function onResize() {
      if (resizeRaf) return;
      resizeRaf = requestAnimationFrame(function() {
        resizeRaf = null;
        updateArrows();
      });
    }

    scrollEl.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', onResize);
    updateArrows();
  }

  function initBubbleArrows() {
    var container = document.querySelector('[data-hero-bubbles]');
    if (!container) return;
    initScrollArrows(
      container.querySelector('[data-bubbles-scroll]'),
      container.querySelector('[data-bubbles-arrow="left"]'),
      container.querySelector('[data-bubbles-arrow="right"]'),
      'tp-scroll-arrow--visible'
    );
  }

  function initProductArrows() {
    var container = document.querySelector('[data-hero-products]');
    if (!container) return;
    initScrollArrows(
      container.querySelector('[data-hero-products-container]'),
      container.querySelector('[data-products-arrow="left"]'),
      container.querySelector('[data-products-arrow="right"]'),
      'tp-scroll-arrow--visible'
    );
  }

  // ==================== HERO SLIDER ====================

  function initHeroSlider() {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;

    var track = slider.querySelector('[data-hero-slider-track]');
    var dots = slider.querySelectorAll('[data-hero-slider-dot]');
    var arrowPrev = slider.querySelector('[data-hero-slider-arrow="prev"]');
    var arrowNext = slider.querySelector('[data-hero-slider-arrow="next"]');
    var config = getConfig();
    if (!track || !config) return;
    if (config.slideCount < 2) return;

    var currentSlide = 0;
    var slideCount = config.slideCount;
    var autoplayTimer = null;

    // Touch/drag state
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;
    var isDragging = false;
    var didSwipe = false;
    var swipeDirection = null; // 'horizontal' | 'vertical' | null
    var sliderWidth = 0;

    function goToSlide(index) {
      if (index < 0) index = slideCount - 1;
      if (index >= slideCount) index = 0;
      currentSlide = index;
      track.classList.remove('tp-hero__slider-track--dragging');
      track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('tp-hero__slider-dot--active', i === currentSlide);
      }
    }

    function startAutoplay() {
      if (!config.enableAutoplay) return;
      stopAutoplay();
      autoplayTimer = setInterval(function() { goToSlide(currentSlide + 1); }, config.autoplayDuration * 1000);
    }

    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }

    // Dot click handlers
    for (var i = 0; i < dots.length; i++) {
      dots[i].addEventListener('click', function() {
        goToSlide(parseInt(this.getAttribute('data-hero-slider-dot'), 10));
        stopAutoplay();
        startAutoplay();
      });
    }

    // Arrow click handlers
    if (arrowPrev) {
      arrowPrev.addEventListener('click', function() {
        goToSlide(currentSlide - 1);
        stopAutoplay();
        startAutoplay();
      });
    }
    if (arrowNext) {
      arrowNext.addEventListener('click', function() {
        goToSlide(currentSlide + 1);
        stopAutoplay();
        startAutoplay();
      });
    }

    // Pause autoplay on hover (desktop)
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    // Touch: start
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchStartTime = Date.now();
      isDragging = true;
      didSwipe = false;
      swipeDirection = null;
      sliderWidth = slider.offsetWidth;
      track.classList.add('tp-hero__slider-track--dragging');
      stopAutoplay();
    }, { passive: true });

    // Touch: move with real-time drag feedback
    track.addEventListener('touchmove', function(e) {
      if (!isDragging) return;

      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;

      // Determine swipe direction on first significant move
      if (!swipeDirection) {
        if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
          swipeDirection = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';
        }
      }

      // Let vertical scrolls pass through
      if (swipeDirection === 'vertical') {
        track.classList.remove('tp-hero__slider-track--dragging');
        return;
      }

      // Prevent vertical scroll during horizontal swipe
      e.preventDefault();

      // Rubber-band at edges
      if ((currentSlide === 0 && dx > 0) || (currentSlide === slideCount - 1 && dx < 0)) {
        dx = dx / 3;
      }

      var baseOffset = -(currentSlide * sliderWidth);
      track.style.transform = 'translateX(' + (baseOffset + dx) + 'px)';
    }, { passive: false });

    // Touch: end
    track.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('tp-hero__slider-track--dragging');

      if (swipeDirection === 'vertical') {
        startAutoplay();
        return;
      }

      var diff = touchStartX - e.changedTouches[0].clientX;
      var elapsed = Date.now() - touchStartTime;
      var velocity = Math.abs(diff) / elapsed; // px/ms

      // Navigate if distance > 40px or fast swipe
      if (Math.abs(diff) > 40 || velocity > 0.3) {
        didSwipe = true;
        goToSlide(currentSlide + (diff > 0 ? 1 : -1));
      } else {
        // Snap back
        goToSlide(currentSlide);
      }

      // Prevent link click after swipe
      if (didSwipe) {
        track.classList.add('tp-hero__slider-track--swiped');
        setTimeout(function() {
          track.classList.remove('tp-hero__slider-track--swiped');
        }, 50);
      }

      startAutoplay();
    }, { passive: true });

    startAutoplay();
  }

  // ==================== RECENTLY VIEWED ====================

  function initRecentlyViewed() {
    var container = document.querySelector('[data-hero-products-container]');
    var heading = document.querySelector('[data-hero-products-heading]');
    var config = getConfig();
    if (!container || !config) return;

    var recentHandles = getRecentlyViewedHandles();
    if (recentHandles.length === 0) return;

    var handles = recentHandles.slice(0, config.productCount || 3);
    if (heading) heading.textContent = config.recentlyViewedHeading || 'Zuletzt angesehen';

    var fallbackProducts = container.querySelectorAll('[data-hero-fallback-product]');
    for (var i = 0; i < fallbackProducts.length; i++) fallbackProducts[i].style.display = 'none';

    for (var j = 0; j < handles.length; j++) {
      fetchProduct(handles[j], function(html) {
        if (html) {
          var card = document.createElement('div');
          card.className = 'tp-hero__product-card';
          card.innerHTML = html;
          container.appendChild(card);
        }
      });
    }
  }

  function getRecentlyViewedHandles() {
    try {
      var data = localStorage.getItem(RECENTLY_VIEWED_KEY);
      if (!data) return [];
      var parsed = JSON.parse(data);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }

  function fetchProduct(handle, callback) {
    fetch('/products/' + handle)
      .then(function(res) {
        if (!res.ok) throw new Error('Product not found');
        return res.text();
      })
      .then(function(html) {
        if (!html) { callback(null); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var item = doc.querySelector('.productitem');
        if (item) {
          var w = document.createElement('div');
          w.appendChild(item.cloneNode(true));
          callback(w.innerHTML);
        } else {
          callback(html);
        }
      })
      .catch(function() { callback(null); });
  }

  // ==================== SEEN STORIES ====================

  function getSeenStories() {
    try {
      var data = localStorage.getItem(SEEN_STORIES_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) { return []; }
  }

  function applySeenClass(bubbleIndex) {
    // Echte Bubble (nicht die Deal-Bubble), damit deren Ring nie ausgegraut wird
    var btn = document.querySelector('.tp-hero__bubble:not(.tp-hero__bubble--deal)[data-story-open="' + bubbleIndex + '"]');
    if (btn) {
      var ring = btn.querySelector('.tp-hero__bubble-ring');
      if (ring) ring.classList.add('tp-hero__bubble-ring--seen');
    }
  }

  function markStorySeen(bubbleIndex) {
    var seen = getSeenStories();
    if (seen.indexOf(bubbleIndex) === -1) {
      seen.push(bubbleIndex);
      try { localStorage.setItem(SEEN_STORIES_KEY, JSON.stringify(seen)); } catch (e) {}
    }
    applySeenClass(bubbleIndex);
  }

  function applySeenStories() {
    var seen = getSeenStories();
    for (var i = 0; i < seen.length; i++) {
      applySeenClass(seen[i]);
    }
  }

  // ==================== STORY VIEWER ====================

  var story = {
    cards: [],        // DOM elements
    cardData: [],     // from JSON
    currentIndex: 0,
    timer: null,
    timerStart: 0,
    timerRemaining: 0,
    duration: 8000,
    isPaused: false,
    isOpen: false,
    suppressLinkClick: false,
    iframesLoaded: {},       // track which cards have loaded iframes
    productsLoaded: {},      // track which cards have loaded products
    // Cached DOM refs
    viewer: null,
    track: null,
    navPrev: null,
    navNext: null
  };

  function initStoryViewer() {
    var config = getConfig();
    var dataEl = document.querySelector('[data-story-data]');
    if (!dataEl) return;

    if (config) {
      story.duration = (config.storyDuration || 8) * 1000;
    }

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    story.cardData = data.cards || [];

    var sPreview = isBubblePreview();
    var sNow = Date.now();

    // Story-Cards aufbereiten: datums-/inaktiv-gehidete entfernen (ausser im
    // Preview), dann absteigend nach data-sort im DOM umordnen. So zeigt der Viewer
    // NUR live Stories und blaettert in derselben Reihenfolge wie die Bubbles
    // (updateTrackPosition nutzt die DOM-Position). Limit-gehidete (#11+) bleiben
    // als Story erhalten — sie sind weiter live, nur nicht als Bubble sichtbar.
    var storyTrack = document.querySelector('[data-story-track]');
    if (storyTrack) {
      var cardNodes = [];
      var rawCards = storyTrack.querySelectorAll('[data-story-card]');
      for (var rc = 0; rc < rawCards.length; rc++) {
        var cnode = rawCards[rc];
        if (!sPreview && !isBubbleLive(cnode.getAttribute('data-active'), cnode.getAttribute('data-start'), cnode.getAttribute('data-end'), sNow)) {
          if (cnode.parentNode) cnode.parentNode.removeChild(cnode);
          continue;
        }
        cardNodes.push(cnode);
      }
      cardNodes.sort(function (a, b) {
        return (parseInt(b.getAttribute('data-sort'), 10) || 0) -
               (parseInt(a.getAttribute('data-sort'), 10) || 0);
      });
      for (var rr = 0; rr < cardNodes.length; rr++) storyTrack.appendChild(cardNodes[rr]);
    }

    story.cards = document.querySelectorAll('[data-story-card]');

    if (story.cards.length === 0) return;

    // cardData an die (gefilterte + sortierte) DOM-Reihenfolge angleichen
    var alignedData = [];
    for (var ad = 0; ad < story.cards.length; ad++) {
      var bIdx = story.cards[ad].getAttribute('data-story-card');
      for (var dk = 0; dk < story.cardData.length; dk++) {
        if (story.cardData[dk].bubbleIndex === bIdx) { alignedData.push(story.cardData[dk]); break; }
      }
    }
    if (alignedData.length === story.cards.length) story.cardData = alignedData;

    // Cache DOM refs
    story.viewer = document.querySelector('[data-story-viewer]');
    story.track = document.querySelector('[data-story-track]');
    story.navPrev = document.querySelector('[data-story-nav-prev]');
    story.navNext = document.querySelector('[data-story-nav-next]');

    // Bubble clicks
    var buttons = document.querySelectorAll('[data-story-open]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', handleBubbleClick);
    }

    // Close buttons (on each card)
    var closeBtns = document.querySelectorAll('[data-story-close-btn]');
    for (var j = 0; j < closeBtns.length; j++) {
      closeBtns[j].addEventListener('click', closeStory);
    }

    // Backdrop close
    var backdrop = document.querySelector('[data-story-close]');
    if (backdrop) backdrop.addEventListener('click', closeStory);

    // Navigation arrows
    if (story.navPrev) story.navPrev.addEventListener('click', function() { navigate(-1); });
    if (story.navNext) story.navNext.addEventListener('click', function() { navigate(1); });

    // Background image link -> collection. Suppress navigation on tap:
    // a plain tap follows the link, swipe/hold is handled by touch handlers.
    var cardLinks = document.querySelectorAll('[data-story-card-link]');
    for (var cl = 0; cl < cardLinks.length; cl++) {
      cardLinks[cl].addEventListener('click', function(e) {
        if (story.suppressLinkClick) {
          e.preventDefault();
          story.suppressLinkClick = false;
          return;
        }
        // Echter Tap auf das Card-Link → Navigation zur Collection (§7).
        window.TP && TP.track('collection_clicked', {
          collection: cardCollection(story.currentIndex)
        });
      });
    }

    // Pause buttons
    var pauseBtns = document.querySelectorAll('[data-story-pause]');
    for (var pb = 0; pb < pauseBtns.length; pb++) {
      pauseBtns[pb].addEventListener('click', togglePause);
    }

    // Keyboard
    document.addEventListener('keydown', function(e) {
      if (!story.isOpen) return;
      if (e.key === 'Escape') closeStory();
      else if (e.key === 'ArrowLeft') navigate(-1);
      else if (e.key === 'ArrowRight') navigate(1);
      else if (e.key === ' ') { e.preventDefault(); togglePause(); }
    });

    // Touch swipe + hold-to-pause on track
    if (story.track) initTouchHandlers(story.track);

    // Stop all shelf interactions from bubbling to tap zones
    var shelves = document.querySelectorAll('[data-story-shelf]');
    for (var sh = 0; sh < shelves.length; sh++) {
      shelves[sh].addEventListener('click', function(e) { e.stopPropagation(); });
    }

  }

  function initTouchHandlers(track) {
    var touchStartX = 0;
    var touchStartY = 0;
    var holdTimer = null;
    var isHolding = false;
    var isShelfScroll = false;
    var didMove = false;

    track.addEventListener('touchstart', function(e) {
      // Don't hijack swipes on the product shelf
      isShelfScroll = !!e.target.closest('[data-story-products-scroll]');
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isHolding = false;
      didMove = false;
      story.suppressLinkClick = false;
      if (!isShelfScroll) {
        holdTimer = setTimeout(function() {
          isHolding = true;
          pauseTimer();
        }, 300);
      }
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > 8 || dy > 8) {
        didMove = true;
        if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      }
    }, { passive: true });

    track.addEventListener('touchend', function(e) {
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      if (isShelfScroll) { isShelfScroll = false; return; }
      if (isHolding) {
        isHolding = false;
        // Hold pauses the story; the release must not follow the image link.
        story.suppressLinkClick = true;
        resumeTimer();
        return;
      }
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        // Swipe navigates and must not trigger the image link.
        story.suppressLinkClick = true;
        navigate(diff > 0 ? 1 : -1);
      } else if (didMove) {
        // Aborted swipe/scroll — neither navigate nor open the link.
        story.suppressLinkClick = true;
      }
    }, { passive: true });
  }

  // Spec 195: Collection-Handle der Story-Card an einem Index (fuer Tracking-props).
  function cardCollection(index) {
    var cd = story.cardData[index];
    return (cd && cd.collection) || null;
  }

  function handleBubbleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var bubbleId = this.getAttribute('data-story-open');
    var fallbackUrl = this.getAttribute('data-fallback-url');
    var titleEl = this.querySelector('.tp-hero__bubble-title');

    // Deal-Lead-CTA ("Aktuelle Angebote"): immer die visuell erste Bubble
    // oeffnen. Cards sind in initStoryViewer absteigend nach data-sort sortiert,
    // also ist Index 0 die vorderste/erste sichtbare Bubble — robust gegen
    // umgekehrte Reihenfolge, Datums-Filter und Bubble-Limit.
    if (bubbleId === 'lead') {
      if (story.cards.length > 0) {
        window.TP && TP.track('bubble_opened', {
          bubble_index: bubbleId,
          title: titleEl && titleEl.textContent,
          collection: cardCollection(0)
        });
        openStory(0);
      }
      else if (fallbackUrl) window.location.href = fallbackUrl;
      return;
    }

    // Find which card index matches this bubble
    var cardIndex = -1;
    for (var i = 0; i < story.cardData.length; i++) {
      if (story.cardData[i].bubbleIndex === bubbleId) {
        cardIndex = i;
        break;
      }
    }

    if (cardIndex >= 0) {
      window.TP && TP.track('bubble_opened', {
        bubble_index: bubbleId,
        title: titleEl && titleEl.textContent,
        collection: cardCollection(cardIndex)
      });
      openStory(cardIndex);
    } else if (fallbackUrl) {
      window.location.href = fallbackUrl;
    }
  }

  // ---- Open / Close ----

  function loadStoryImage(index) {
    var card = story.cards[index];
    if (!card) return;
    var img = card.querySelector('.tp-story__card-image[data-src]');
    if (!img) return;
    var ss = img.getAttribute('data-srcset');
    img.addEventListener('load', function () {
      var loader = card.querySelector('.tp-story__loader');
      if (loader) loader.style.display = 'none';
    });
    if (ss) img.setAttribute('srcset', ss);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function showCard(index) {
    updateActiveCard();
    loadStoryImage(index);
    if (index + 1 < story.cards.length) loadStoryImage(index + 1);
    if (index - 1 >= 0) loadStoryImage(index - 1);
    loadIframe(index);
    loadStoryProducts(index);
    startTimer();
    updatePauseIcon(false);
    var cardData = story.cardData[index];
    if (cardData && cardData.bubbleIndex) {
      markStorySeen(cardData.bubbleIndex);
    }
    window.TP && TP.track('story_card_viewed', {
      bubble_index: cardData && cardData.bubbleIndex,
      card_index: index,
      collection: cardCollection(index)
    });
  }

  function openStory(index) {
    story.currentIndex = index;
    story.isPaused = false;
    story.isOpen = true;
    window.TP && TP.track('story_viewed', {
      bubble_index: story.cardData[index] && story.cardData[index].bubbleIndex,
      collection: cardCollection(index)
    });

    story.viewer.classList.remove('tp-story--closing');
    story.viewer.classList.add('tp-story--open');
    story.viewer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    updateTrackPosition(false);
    showCard(index);
  }

  function closeStory() {
    if (!story.isOpen) return;
    story.isOpen = false;
    stopTimer();

    story.viewer.classList.add('tp-story--closing');
    story.viewer.classList.remove('tp-story--open');

    setTimeout(function() {
      story.viewer.classList.remove('tp-story--closing');
      story.viewer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Remove active class
      for (var i = 0; i < story.cards.length; i++) {
        story.cards[i].classList.remove('tp-story__card--active');
      }
    }, 350);
  }

  // ---- Navigation ----

  function navigate(direction) {
    var newIndex = story.currentIndex + direction;
    if (newIndex < 0 || newIndex >= story.cards.length) {
      if (direction > 0) closeStory();
      return;
    }
    story.currentIndex = newIndex;
    story.isPaused = false;
    updateTrackPosition(true);
    showCard(newIndex);
  }

  function updateTrackPosition(animate) {
    if (!story.track) return;

    // Calculate offset to center the active card
    var card = story.cards[story.currentIndex];
    if (!card) return;

    var cardWidth = card.offsetWidth;
    var gap = 16; // matches CSS gap
    var isMobile = window.innerWidth < 768;
    if (isMobile) gap = 0;

    var totalCardWidth = cardWidth + gap;
    var offset = story.currentIndex * totalCardWidth;
    var centerOffset = (window.innerWidth - cardWidth) / 2;

    story.track.style.transition = animate ? 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
    story.track.style.transform = 'translateX(' + (-offset + centerOffset) + 'px)';

    // Update arrow states
    if (story.navPrev) story.navPrev.disabled = story.currentIndex === 0;
    if (story.navNext) story.navNext.disabled = story.currentIndex === story.cards.length - 1;
  }

  function updateActiveCard() {
    for (var i = 0; i < story.cards.length; i++) {
      story.cards[i].classList.toggle('tp-story__card--active', i === story.currentIndex);
    }
  }

  function loadIframe(index) {
    if (story.iframesLoaded[index]) return;

    var card = story.cards[index];
    if (!card) return;
    var contentEl = card.querySelector('.tp-story__card-content');
    if (!contentEl) return;

    var cardData = story.cardData[index];
    if (!cardData) return;

    // Skip if this is an image card (image already in HTML)
    if (cardData.type === 'image') {
      story.iframesLoaded[index] = true;
      return;
    }

    if (!cardData.instagram_url) return;

    var postCode = extractInstagramCode(cardData.instagram_url);
    if (!postCode) return;

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.instagram.com/p/' + postCode + '/embed/captioned/';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('scrolling', 'yes');

    iframe.addEventListener('load', function() {
      this.classList.add('tp-story__iframe--loaded');
      var loader = contentEl.querySelector('.tp-story__loader');
      if (loader) loader.style.display = 'none';
    });

    contentEl.appendChild(iframe);
    story.iframesLoaded[index] = true;

    // Preload neighbors
    if (index + 1 < story.cards.length) preloadIframe(index + 1);
    if (index - 1 >= 0) preloadIframe(index - 1);
  }

  function preloadIframe(index) {
    if (story.iframesLoaded[index]) return;
    // Delay preload slightly
    setTimeout(function() { loadIframe(index); }, 500);
  }

  function extractInstagramCode(url) {
    if (!url) return null;
    var match = url.match(/instagram\.com\/(?:p|reel|tv)\/([A-Za-z0-9_-]+)/);
    return match ? match[1] : null;
  }

  // ---- Story Products Shelf ----

  function loadStoryProducts(index) {
    if (story.productsLoaded[index]) return;

    var cardData = story.cardData[index];
    if (!cardData || !cardData.collection) return;

    var card = story.cards[index];
    if (!card) return;

    var scrollContainer = card.querySelector('[data-story-products-scroll]');
    if (!scrollContainer) return;

    story.productsLoaded[index] = true;

    fetch('/collections/' + cardData.collection + '?view=story-products')
      .then(function(res) {
        if (!res.ok) throw new Error('Collection not found');
        return res.text();
      })
      .then(function(html) {
        scrollContainer.innerHTML = html;
        // Make product links stop event propagation so tap zones don't fire
        var clickables = card.querySelectorAll('[data-story-product]');
        for (var i = 0; i < clickables.length; i++) {
          clickables[i].addEventListener('click', function(e) { e.stopPropagation(); });
        }
        // Scroll hint animation — wait for images to load before checking dimensions
        var images = scrollContainer.querySelectorAll('img');
        var loaded = 0;
        var total = images.length;
        function checkScrollHint() {
          if (scrollContainer.scrollWidth > scrollContainer.clientWidth + 8) {
            setTimeout(function() {
              // echter Scroll-Nudge: kurz nach rechts, dann zurück -> "da ist mehr"
              scrollContainer.scrollTo({ left: 64, behavior: 'smooth' });
              setTimeout(function() {
                scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
              }, 750);
            }, 350);
          }
        }
        if (total === 0) {
          checkScrollHint();
        } else {
          for (var k = 0; k < total; k++) {
            if (images[k].complete) {
              loaded++;
              if (loaded === total) checkScrollHint();
            } else {
              images[k].addEventListener('load', function() {
                loaded++;
                if (loaded === total) checkScrollHint();
              }, { once: true });
              images[k].addEventListener('error', function() {
                loaded++;
                if (loaded === total) checkScrollHint();
              }, { once: true });
            }
          }
        }
      })
      .catch(function() {
        scrollContainer.innerHTML = '';
        var shelf = card.querySelector('[data-story-shelf]');
        if (shelf) shelf.style.display = 'none';
      });
  }

  // ---- Timer ----

  function startTimer() {
    stopTimer();
    story.isPaused = false;
    story.timerRemaining = story.duration;
    story.timerStart = Date.now();

    var card = story.cards[story.currentIndex];
    if (!card) return;
    var fill = card.querySelector('.tp-story__progress-fill');
    if (fill) {
      fill.style.transition = 'none';
      fill.style.width = '0%';
      fill.offsetWidth; // reflow, damit der Reset greift
      // volles Shorthand setzen — sonst bleibt transition-property auf 'none' (Sprung)
      fill.style.transition = 'width ' + story.duration + 'ms linear';
      fill.style.width = '100%';
    }

    story.timer = setTimeout(function() {
      navigate(1);
    }, story.duration);
  }

  function stopTimer() {
    if (story.timer) { clearTimeout(story.timer); story.timer = null; }
  }

  function pauseTimer() {
    if (story.isPaused) return;
    story.isPaused = true;
    stopTimer();

    var elapsed = Date.now() - story.timerStart;
    story.timerRemaining = Math.max(0, story.timerRemaining - elapsed);

    var card = story.cards[story.currentIndex];
    if (!card) return;
    var fill = card.querySelector('.tp-story__progress-fill');
    if (fill) {
      // aktuellen Wert ZUERST lesen — getComputedStyle ist live und springt
      // sonst nach transition:none sofort auf den Zielwert (100%).
      var current = window.getComputedStyle(fill).width;
      fill.style.transition = 'none';
      fill.style.width = current;
      fill.offsetWidth; // reflow, damit der eingefrorene Zustand greift
    }
  }

  function resumeTimer() {
    if (!story.isPaused) return;
    story.isPaused = false;
    story.timerStart = Date.now();

    var card = story.cards[story.currentIndex];
    if (!card) return;
    var fill = card.querySelector('.tp-story__progress-fill');
    if (fill) {
      fill.offsetWidth;
      fill.style.transition = 'width ' + story.timerRemaining + 'ms linear';
      fill.style.width = '100%';
    }

    story.timer = setTimeout(function() {
      navigate(1);
    }, story.timerRemaining);
  }

  var PAUSE_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
  var PLAY_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z"/></svg>';

  function updatePauseIcon(paused) {
    var btns = document.querySelectorAll('[data-story-pause]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].innerHTML = paused ? PLAY_ICON : PAUSE_ICON;
      btns[i].setAttribute('aria-label', paused ? 'Weiter' : 'Pause');
    }
  }

  function togglePause() {
    if (story.isPaused) {
      resumeTimer();
    } else {
      pauseTimer();
    }
    updatePauseIcon(story.isPaused);
  }

  // ==================== BUBBLE SCHEDULE (aktiv + Zeitfenster) ====================

  // Blendet Bubbles aus, die inaktiv oder ausserhalb von starts_at/ends_at sind.
  // Sekundengenau, Shop-Zeitzone via ISO-Offset in den data-Attributen.
  // Vorschau-Modus: im Theme-Editor (Shopify.designMode) ODER mit ?bubble_preview=1
  // werden ALLE Bubbles gezeigt — auch inaktive oder ausserhalb des Zeitfensters.
  // Preview-only-Bubbles bekommen einen gestrichelten Rahmen als Hinweis.
  function isBubblePreview() {
    return (window.Shopify && window.Shopify.designMode) ||
           /[?&]bubble_preview=1/.test(window.location.search);
  }

  // Ist die Bubble/Story aktuell live? (aktiv + innerhalb starts_at/ends_at)
  function isBubbleLive(activeAttr, startStr, endStr, now) {
    var ok = activeAttr !== 'false';
    if (ok && startStr) { var ts = Date.parse(startStr); if (!isNaN(ts) && now < ts) ok = false; }
    if (ok && endStr) { var te = Date.parse(endStr); if (!isNaN(te) && now > te) ok = false; }
    return ok;
  }

  // Pro Bubble-Leiste: 1) Datumsfilter (aktiv + Zeitfenster), 2) absteigend nach
  // data-sort, 3) auf data-bubble-limit kürzen. Limit-gehidete Bubbles (#11+) bleiben
  // im DOM und ihre Story bleibt im Viewer durchblätterbar; datums-/inaktiv-gehidete
  // werden dagegen auch aus dem Viewer entfernt (siehe initStoryViewer).
  function applyBubbleSchedule() {
    var preview = isBubblePreview();
    var now = Date.now();
    var containers = document.querySelectorAll('[data-bubbles-scroll]');

    for (var c = 0; c < containers.length; c++) {
      var container = containers[c];
      var btns = container.querySelectorAll('.tp-hero__bubble[data-active]');
      var visible = [];

      for (var i = 0; i < btns.length; i++) {
        var el = btns[i];
        el.style.display = '';
        var ok = isBubbleLive(el.getAttribute('data-active'), el.getAttribute('data-start'), el.getAttribute('data-end'), now);
        if (!ok) {
          if (preview) {
            // sichtbar lassen, aber als "noch nicht live" markieren
            el.style.outline = '2px dashed #f59e0b';
            el.style.outlineOffset = '2px';
            el.style.opacity = '0.6';
            el.title = 'Vorschau – diese Bubble ist live noch nicht sichtbar';
            visible.push(el);
          } else {
            el.style.display = 'none';
          }
        } else {
          visible.push(el);
        }
      }

      // absteigend nach Sortierwert (höchste sort_order zuerst)
      visible.sort(function (a, b) {
        return (parseInt(b.getAttribute('data-sort'), 10) || 0) -
               (parseInt(a.getAttribute('data-sort'), 10) || 0);
      });

      // Limit: nur die ersten N als Bubble anzeigen (im Preview alle zeigen)
      var limit = parseInt(container.getAttribute('data-bubble-limit'), 10);
      for (var k = 0; k < visible.length; k++) {
        visible[k].style.order = k;
        if (!preview && limit && k >= limit) {
          visible[k].style.display = 'none';
        }
      }

      // Erst jetzt — nach Filter/Sortierung/Limit — die Leiste sichtbar machen,
      // damit inaktive/ueberzaehlige Bubbles nicht kurz aufblitzen (FOUC-Schutz).
      container.classList.add('tp-bubbles-ready');
    }
  }

  // ==================== DEAL BUBBLE (rotierende Texte) ====================

  function initDealBubble() {
    var roll = document.querySelector('[data-deal-roll]');
    if (!roll) return;
    var messages = [].slice.call(roll.querySelectorAll('span'));
    if (messages.length < 2) return; // bei einer Nachricht: statisch
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    // Zwischen jede Nachricht einen nach rechts zeigenden Pfeil einschieben:
    // Nachricht -> Pfeil -> Nachricht -> Pfeil -> ...
    var ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M4 12h13M12 6l6 6-6 6" stroke="#fff" stroke-width="2.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var sequence = [];
    for (var i = 0; i < messages.length; i++) {
      sequence.push(messages[i]);
      var arrow = document.createElement('span');
      arrow.className = 'tp-hero__deal-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.innerHTML = ARROW_SVG;
      roll.appendChild(arrow); // absolut positioniert (inset:0), DOM-Reihenfolge egal
      sequence.push(arrow);
    }

    var idx = 0; // sequence[0] = erste Nachricht, ist im Liquid bereits is-active
    function tick() {
      var current = sequence[idx];
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      idx = (idx + 1) % sequence.length;
      var next = sequence[idx];
      next.classList.remove('is-leaving');
      next.classList.add('is-active');
      (function(prev) {
        setTimeout(function() { prev.classList.remove('is-leaving'); }, 500);
      })(current);
      // Pfeile kuerzer zeigen als Nachrichten
      var dwell = next.className.indexOf('tp-hero__deal-arrow') !== -1 ? 850 : 2600;
      setTimeout(tick, dwell);
    }
    setTimeout(tick, 2600);
  }

  // ==================== INIT ====================

  function init() {
    initBubbleArrows();
    initProductArrows();
    initHeroSlider();
    initRecentlyViewed();
    initStoryViewer();
    applySeenStories();
    applyBubbleSchedule();
    initDealBubble();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
